import React from 'react';
import { Link } from 'react-router-dom';
import { placeholderSvgDataUrl } from '../utils/placeholderImage';

function truncate(text, minWords = 10) {
  const words = (text || '').split(/\s+/).filter(Boolean);
  if (words.length <= minWords) return text || '';
  return words.slice(0, minWords).join(' ') + '...';
}

const ProductCard = ({ product, index = 0 }) => {
  const title = product?.title || product?.name || 'Product';
  const description = product?.description || '';
  const imageSrc = product?.image
    ? product.image
    : Array.isArray(product?.images) && product.images.length
      ? product.images[0]
      : placeholderSvgDataUrl({ width: 400, height: 400, text: title });

  return (
    <div
      className="product-card-new"
      style={{
        animation: `fadeSlideUp 0.5s ease forwards`,
        animationDelay: `${(index % 20) * 0.06}s`,
        opacity: 0,
        minWidth: 0,
      }}
    >
      <Link to={`/product/${product.id}`} className="product-card-new-link">
        <div className="product-card-new-image" style={{ aspectRatio: '1 / 1.15' }}>
          <img
            src={imageSrc}
            alt={title}
            loading="lazy"
          />
        </div>

        <div className="product-card-new-body">
          <h3 className="product-card-new-title">{title}</h3>

          <p className="product-card-new-desc">
            {truncate(description, 10)}
          </p>
        </div>
      </Link>
    </div>
  );
};

export default ProductCard;
